export const environment = {
  production: true,
  nightly: false,
  hasVideo: false
};
